import React from 'react';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { useNavigate } from 'react-router-dom';
import { Button, Card, CardContent, Typography, Grid } from '@mui/material';

const CheckSignOut = () => {
    const { signOut } = useAuthenticator();
    const navigate = useNavigate();

    const handleSignOut = () => {
        signOut();
        navigate('/'); // ホームページに戻る
    };

    const handleCancel = () => {
        navigate(-1); // 前のページに戻る
    };

    return (
        <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center"
            style={{ minHeight: '100vh' }}
        >
            <Grid item xs={3}>
                <Card sx={{ padding: 3, maxWidth: 400, boxShadow: 3 }}>
                    <CardContent>
                        <Typography variant="h5" component="div" align="center" gutterBottom>
                            ログアウトの確認
                        </Typography>
                        <Typography variant="body1" color="text.secondary" align="center" gutterBottom>
                            ログアウトしますか？
                        </Typography>
                        <Grid container spacing={2} justifyContent="center" sx={{ mt: 2 }}>
                            <Grid item>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleSignOut}
                                >
                                    ログアウトする
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button
                                    variant="outlined"
                                    color="secondary"
                                    onClick={handleCancel}
                                >
                                    キャンセル
                                </Button>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    );
};

export default CheckSignOut;
